import React from 'react'
import PropTypes from 'prop-types'
import { userPropTypes } from '../../../prop-types'
import Circle from '../../common/Circle'
import Column from '../../common/Column'
import Text from '../../common/Text'
import Icon from '../../common/Icon'
import Block from '../../common/Block'
import Spacer from '../../common/Spacer'
import ImageBackground from '../../common/ImageBackground'
import TreesCounter from '../TreesCounter'
import { AVATARS } from '../../../constants'

const WIDTH = '100%' // 112
const MASK_SIZE = 50
const CIRCLE_SIZE = 70
const DELTA = 1.5

const STEPS = {
    1: {
        height: 200,
    },
    2: {
        height: 150,
    },
    3: {
        height: 125,
    },
}

const BORDER_RADIUS = 22

const PodiumPosition = ({
    user,
    position,
    isMe,
}) => (
    <Column width={WIDTH}>
        {isMe ? (
            <ImageBackground
                imageName="laurels@2x.png"
                width={DELTA * MASK_SIZE}
                height={DELTA * MASK_SIZE}
                justifyContent="center"
                style={{
                    alignSelf: 'center',
                }}
            >
                <Icon
                    iconName={`${user.profile?.avatar || AVATARS[0]}@2x.png`}
                    alt="mask"
                    height={MASK_SIZE}
                    width={MASK_SIZE}
                    alignSelf="center"
                />
                <Spacer size="S" />
            </ImageBackground>
        ) : (
            <Circle
                radius={CIRCLE_SIZE}
                borderColor="white"
                alignItems="center"
                justifyContent="center"
                bgColor="lightGrey3"
                style={{
                    alignSelf: 'center',
                }}
            >
                <Icon
                    iconName={`${user.profile?.avatar || AVATARS[0]}@2x.png`}
                    alt="mask"
                    height={MASK_SIZE}
                    width={MASK_SIZE}
                    alignSelf="center"
                />
            </Circle>
        )}
        <Block p="XXXS" pt="XS" pb="L">
            <Text size="S" semibold center style={{ wordBreak: 'break-all' }}>
                {user.profile?.nickname.length > 35
                    ? `${user.profile.nickname.substring(0, 35)}...`
                    : (user.profile?.nickname || 'Incognito')}
            </Text>
        </Block>
        <Column
            bgColor="lightBlue1"
            alignItems="center"
            style={{
                height: `${STEPS[position].height}px`,
                borderTopLeftRadius: `${position === 3 ? 0 : BORDER_RADIUS}px`,
                borderTopRightRadius: `${position === 2 ? 0 : BORDER_RADIUS}px`,
            }}
        >
            <Block pt="XXS">
                <Text size="XXXL" color="white" center>
                    {position}
                </Text>
            </Block>
            <Spacer size="S" />
            <Block pb="M">
                <TreesCounter big trees={user.trees} alignSelf="center" />
            </Block>
        </Column>
    </Column>
)

PodiumPosition.propTypes = {
    user: userPropTypes.isRequired,
    position: PropTypes.number,
    isMe: PropTypes.bool,
}

PodiumPosition.defaultProps = {
    position: 1,
    isMe: false,
}

export default PodiumPosition
